import { useState } from "react";

import "react-loading-skeleton/dist/skeleton.css";

import useWindowDimensions from "../../hooks/useWindowDimentions";

import useSWR from "swr";

import { FetchWallOfFame } from "../../lib/FetchWallOfFame";

import "react-multi-carousel/lib/styles.css";
import { NextArrow, PrevArrow } from "../ui/Arrows";
import WallOfFameSkeleton from "../WallOfFame/WallOfFameCard/Skeleton";
import WallOfFameCard from "../WallOfFame/WallOfFameCard";

export default function GridLayout() {
  const [currentPage, setCurrentPage] = useState(1);
  const items: Record<number, number> = {
    1920: 102,
    1200: 102,
    850: 30,
    720: 30,
    650: 20,
    480: 10,
  };
  const { range } = useWindowDimensions();
  const [itemsPerPage] = useState(items[range]);

  const { data: students, isLoading } = useSWR(
    currentPage
      ? `/wp-json/wall-of-fame/v1/weekly-wall?page=${currentPage}&per_page=${itemsPerPage}`
      : "",
    () => FetchWallOfFame(currentPage, itemsPerPage),
    { revalidateOnFocus: false }
  );

  const users = students?.data || [];
  const total = students?.total || 0;

  if (isLoading) {
    return (
      <div className="grid xl:grid-cols-6 lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 m-4">
        {Array.from({ length: items[range] }).map((_, index) => (
          <WallOfFameSkeleton key={index} />
        ))}
      </div>
    );
  }

  return (
    <>
      <div className="grid xl:grid-cols-6 lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 m-4">
        {users &&
          users.map((user, idx) => <WallOfFameCard {...user} key={idx} />)}
      </div>
      <div className="arrow-wrapper flex justify-center items-center bg-slate-100 py-2 gap-2">
        <div className="prev-btn">
          <PrevArrow
            onClick={() =>
              setCurrentPage((currentPage) =>
                currentPage === 1
                  ? Math.ceil(total / itemsPerPage)
                  : currentPage - 1
              )
            }
          />
        </div>
        <div className="total-pages">
          {currentPage} of {Math.ceil(total / itemsPerPage)} pages
        </div>
        <div className="next-btn">
          <NextArrow
            onClick={() => {
              setCurrentPage((currentPage) =>
                Math.ceil(total / itemsPerPage) > currentPage
                  ? currentPage + 1
                  : 1
              );
            }}
          />
        </div>
      </div>
    </>
  );
}
